<div [ngClass]="fromNewMessage ? 'chatMainNEWMSG' : 'chatmain'">
  <div class="card chat-app chat-chat">
    <div class="chat">
      <div class="chat-header clearfix" *ngIf="!fromNewMessage">
        <div class="row align-items-center">
          <div class="chat-about col">
            <span class="chat-user-name">{{getGroupName()}} {{ getToUserName() }}</span>
          </div>
          <div class="col-auto">
            <button mat-icon-button (click)="close()" class="close-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <!-- <div *ngIf="groupName && alertGroup && chatList[0] ? chatList[chatList.length-1].fromUserId !== groupName : false" class="row"> -->
        <div
          *ngIf="groupName && alertGroup && chatList[0] ? chatList[chatList.length-1].fromUserId !== chatList[chatList.length-1].toUserId : false"
          class="row">
          <div class="col text-center" style="display: flex; justify-content: space-evenly;">
            <button class="btn btn-primary" (click)="handleOnIt()">On it</button>
            <button class="btn btn-danger" (click)="handleRemoveAlert()">Turn Off Alert</button>
          </div>
        </div>
      </div>
      <div class="chat-history" #chathistory>
        <button *ngIf="chatList.length > 20 && !loadAll" class="mb-3" (click)="getChatHistory(true)">
          {{ "CHAT.LOAD_MORE" | translate }}
        </button>
        <ul class="m-b-0">
          <li *ngIf="chatList.length === 0">
            <h4>No Message History</h4>
          </li>
          <ng-container *ngFor="let chat of chatList; let i = index">
            <li class="clearfix d-flex" [ngClass]="isSender(chat) ? 'justify-content-end' : 'justify-content-start'">
              <mat-checkbox *ngIf="isSender(chat)" class="custom-frame" (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(chat) : null" [checked]="selection.isSelected(chat)">
              </mat-checkbox>
              <div class="message" [ngClass]="isSender(chat) ? 'other-message' : 'my-message'">
                <div (click)="bringToInternalPage(chat.message)" *ngIf="chat.messageType === 'TEXT'"
                  [innerHTML]="getDisplayMessage(chat) | httpLink"></div>
                <div *ngIf="chat.messageType === 'BROADCAST'">
                  {{ chat.message }}
                  <div>
                    <span *ngIf="chat?.isAvailable === true" style="color: green">{{ "CHAT.USER_ACCEPTED" | translate
                      }}</span>
                    <span *ngIf="chat?.isAvailable === false" style="color: red">{{ "CHAT.USER_REJECTED" | translate
                      }}</span>
                  </div>
                </div>
                <div *ngIf="chat.messageType === 'MEDIA'">
                  <a style="cursor: pointer" (click)="fileDownload(chat.media)"><i class="fa fa-paperclip"></i> {{
                    chat.mediaThumb }}</a>
                </div>

                <div class="timestamp">
                  <i *ngIf="isSender(chat)" [ngClass]="messageStatusIcon(chat)" [ngStyle]="colorIcon(chat)"></i>
                  {{ chat.createTime | dateAgo }}
                </div>
              </div>

              <mat-checkbox *ngIf="!isSender(chat)" class="custom-frame float-right" (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(chat) : null" [checked]="selection.isSelected(chat)">
              </mat-checkbox>
            </li>
          </ng-container>
        </ul>
      </div>

      <div class="chat-message clearfix">
        <mat-spinner style="height: 50px !important" *ngIf="isUploadingMedia"></mat-spinner>
        <div class="top-buttons">
          <div *ngIf="selection.hasValue()">
            <button class="fill-width sc-btn gold-gradient center" style="padding-right:  0.70rem;"
              (click)="gotoForwardMessage()">
              <mat-icon>arrow_forward</mat-icon>
              Forward Message
            </button>
          </div>

          <div *ngIf="selection.hasValue() && isuserRealm && canCreateThread" style="margin-left: 4px;">
            <button class="fill-width sc-btn create-ticket-btn center" style="padding-right:  0.70rem;"
              (click)="gotoCreateTicket()">
              <mat-icon style="color: white;">add</mat-icon>
              Create Ticket
            </button>
          </div>
        </div>




        <div *ngIf="!selection.hasValue()" class="input-group mb-0 chatContainer">
          <!-- <div *ngIf="!selection.hasValue()" class="input-group mb-0" style="position:absolute;bottom:1;left:0"> -->
          <span class="input-group-text chat-icon-btn" style="cursor: pointer; align-self: stretch; display: flex; align-items: center"
            (click)="fileInput.click()">
            <input style="display: none" type="file" (change)="onFileChanged($event, 'MEDIA')" #fileInput />
            <i class="fa fa-paperclip"></i>
          </span>
          <textarea rows="1" name="message" class="form-control" #chat_input
            placeholder="Type a message" [(ngModel)]="message"
            (input)="autoResizeTextarea($event)" (paste)="onPaste($event)"></textarea>
          <span class="input-group-text chat-icon-btn" style="cursor: pointer; align-self: stretch; display: flex; align-items: center"
            (click)="sendMessage()">
            <i class="fa fa-paper-plane"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>